import React from "react";
import "../styles/Footer.css";
import { FOOTER_CONSTANTS } from "../utils/profitable_harvest";

const Footer = () => {
  return (
    <footer className="footer">
      <div
        className="footer-cta"
        style={{ backgroundImage: `url(${FOOTER_CONSTANTS.CTA_BACKGROUND})` }}
      >
        <h2>{FOOTER_CONSTANTS.CTA_TITLE}</h2>
        <div className="cta-form">
          <input
            type="email"
            placeholder={FOOTER_CONSTANTS.EMAIL_PLACEHOLDER}
          />
          <button className="join-now">{FOOTER_CONSTANTS.BUTTON_TEXT}</button>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="footer-divider">
          <div className="copyright">{FOOTER_CONSTANTS.COPYRIGHT}</div>
          <div className="legal-links">
            <a href="#privacy-policy">Privacy Policy</a>
            <a href="#terms-of-use">Terms Of Use</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
